export default class webglManager {
    constructor(){
        this.target = $('#vue-switch-scene').find('.p-switch-scene__item');
    }

    /* -----------------------------------------------

     -- update

     -------------------------------------------------- */

    update(_status) {

        switch (_status.nextcurrent) {
            case 0: //HOME
                _status.webglnumber = 2;
                break;
            case 1: //about
                _status.webglnumber = 4;
                break;
            case 2: //technology
                _status.webglnumber = 4;
                break;
            case 3: //iot
                _status.webglnumber = 5;
                break;
            case 4: //digiatltwin
                _status.webglnumber = 6;
                break;
            case 5: //development
                _status.webglnumber = 9;
                break;
            case 6: //developer
                _status.webglnumber = 9;
                break;
            case 7: //contact
                _status.webglnumber = 9;
                break;
            case 8:
                _status.webglnumber = 9;
                break;
            case 9:
                _status.webglnumber = 9;
                break;
        }
        this.target.eq(_status.webglnumber).click();

    }
    startstop(_status){
        this.target.eq(11).click();
        if(_status.webglplay){
            _status.webglplay = false;
        }else{
            _status.webglplay = true;
        }
    }

}
